export enum ServiceType {
  HomeDelivery = 'HOME_DELIVERY',
  Collect = 'COLLECT',
  ClickCollectStore = 'CLICK_COLLECT_STORE',
  PickupPoint = 'PUP',
  PickupPointExternal = 'PUOP',
  Locker = 'LOCKER',
  ClickCollect = 'CLICK_COLLECT',
}
